<div class="relative inline-flex">
  <button
    type="button"
    class="group relative inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 shadow-sm transition-[background-color,color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:bg-white hover:text-slate-800 hover:shadow-md dark:bg-slate-800 dark:text-slate-200 dark:shadow-none dark:hover:bg-slate-700 dark:hover:text-white"
    [attr.aria-label]="tooltip()"
    [attr.aria-expanded]="isTooltipVisible()"
    (mouseenter)="showTooltip()"
    (mouseleave)="hideTooltip()"
    (focus)="showTooltip()"
    (blur)="hideTooltip()"
    (click)="toggleTooltip()"
  >
    <i class="fa-solid fa-wifi text-[13px]" [class.opacity-80]="isOnline()" [class.opacity-55]="!isOnline()"></i>
    <span
      class="absolute right-1 top-1 h-2.5 w-2.5 rounded-full border border-white dark:border-slate-900"
      [ngClass]="isOnline() ? 'bg-emerald-500' : 'bg-red-500'"
    ></span>

    @if (isSyncing()) {
      <span class="sync-status-ping absolute inset-0 rounded-full border border-sky-400/70"></span>
    }
  </button>

  @if (isTooltipVisible()) {
    <div
      class="sync-status-tooltip absolute right-0 top-[calc(100%+0.6rem)] z-[90] w-52 rounded-xl bg-slate-900 px-3 py-2 text-xs font-medium text-white shadow-xl dark:bg-slate-950"
      role="tooltip"
      (mouseenter)="showTooltip()"
      (mouseleave)="hideTooltip()"
    >
      {{ tooltip() }}
      <span class="sync-status-tooltip-arrow absolute -top-1 right-3 h-2.5 w-2.5 rotate-45 bg-slate-900 dark:bg-slate-950"></span>
    </div>
  }
</div>
